import React from "react";
import Joyride, { STATUS } from "react-joyride";
import { PRIMARY_TABS } from "../copy/tabCopy";

const STORAGE = "odcg_onboarding_done_v1";

export default function OnboardingTour({ run, onDone }) {
  const steps = [
    {
      target: '[data-tour="app-main"]',
      placement: "center",
      content: (
        <div>
          <p className="mb-2 font-semibold text-fg">Welcome</p>
          <p className="text-sm text-fg-secondary">
            Use the top tabs for overview, data tools, regulations, and sources. Keyboard: Tab through controls; Esc closes dialogs.
          </p>
        </div>
      ),
      disableBeacon: true,
    },
    ...PRIMARY_TABS.map((t) => ({
      target: `[data-tour="${t.tourId}"]`,
      content: (
        <div>
          <p className="mb-1 font-semibold text-fg">{t.title}</p>
          <p className="text-sm text-fg-secondary">{t.description}</p>
        </div>
      ),
    })),
    {
      target: '[data-tour="footer-newsletter"]',
      content: <p className="text-sm text-fg-secondary">Subscribe for product and regulation digests when you connect your newsletter provider.</p>,
    },
  ];

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showSkipButton
      scrollToFirstStep
      styles={{
        options: { primaryColor: "#0d9488", textColor: "#18181b", zIndex: 20000 },
        tooltip: { borderRadius: 12 },
        buttonNext: { outline: "none" },
        buttonBack: { outline: "none" },
      }}
      locale={{ back: "Back", close: "Close", last: "Done", next: "Next", skip: "Skip tour" }}
      callback={(data) => {
        if (data.status === STATUS.FINISHED || data.status === STATUS.SKIPPED) {
          try {
            localStorage.setItem(STORAGE, "1");
          } catch {
            /* ignore */
          }
          onDone?.();
        }
      }}
    />
  );
}

export function shouldAutoStartTour() {
  try {
    return !localStorage.getItem(STORAGE);
  } catch {
    return true;
  }
}
